import { useEffect, useState } from "react";
import {
  Container,
  Card,
  Table,
  Button,
  Spinner,
  Alert,
  Badge,
  Row,
  Col,
} from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { FaDownload } from "react-icons/fa6";
import { GrView } from "react-icons/gr";

import {
  downloadHrOrgDocument,
  getAllHrDocumentTypes,
  getVisibleHrOrgDocuments,
  viewHrOrgDocument,
} from "../Api/HrOrgDocumentMasterApi";

import { getDepartmentsByOrgId } from "../Api/DepartmentOrgMaster";
import { getResourceByMavUserId } from "../Api/ResourceList";

const ViewHrOrgDocuments = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const orgId = String(userDetails?.organisationId);
  const userId = String(userDetails?.userId);

  const [documents, setDocuments] = useState([]);
  const [documentTypeMap, setDocumentTypeMap] = useState({});
  const [userDepartmentIds, setUserDepartmentIds] = useState([]);
  const [loading, setLoading] = useState(false);

  // ================= INIT =================

  useEffect(() => {
    if (orgId && userId) {
      fetchUserResource();
      fetchDocumentTypes();
    }
  }, [orgId, userId]);

  useEffect(() => {
    fetchDocuments();
  }, [userDepartmentIds]);

  // ================= DATA =================

  const fetchUserResource = async () => {
    try {
      const data = await getResourceByMavUserId(userId);
      const deptCode = data?.resource?.department;
      setUserDepartmentIds(deptCode ? [String(deptCode)] : []);
    } catch {
      setUserDepartmentIds([]);
    }
  };

  const fetchDocumentTypes = async () => {
    const data = await getAllHrDocumentTypes();
    const map = {};
    data.forEach((t) => (map[t.documentTypeId] = t.documentTypeName));
    setDocumentTypeMap(map);
  };

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      const data = await getVisibleHrOrgDocuments(
        orgId,
        userId,
        userDepartmentIds,
      );
      setDocuments(data || []);
    } catch {
      toast.error("Failed to load documents");
    } finally {
      setLoading(false);
    }
  };

  // ================= UI =================

  return (
    <Container fluid className="main-content expand">
      <Card className="shadow-sm">
        <Card.Header className="bg-white">
          <Row className="align-items-center">
            <Col>
              <p style={{ fontSize: "25px" }} className="mb-0">
                📂 Policies
              </p>
              <small className="text-muted">
                View available organization documents
              </small>
            </Col>
          </Row>
        </Card.Header>

        <Card.Body>
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          ) : documents.length ? (
            <Table hover responsive className="align-middle">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Id</th>
                  <th>Document</th>
                  <th>Type</th>
                  <th>Version</th>
                  <th>Created</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {documents.map((doc, i) => (
                  <tr key={doc.documentId}>
                    <td>{i + 1}</td>
                    <td>{doc.documentId}</td>
                    <td className="fw-semibold">{doc.documentTitle}</td>
                    <td>
                      <Badge bg="info">
                        {documentTypeMap[doc.documentType]}
                      </Badge>
                    </td>
                    <td>{doc.documentVersion}.0</td>
                    <td>{moment(doc.createdOnDate).format("DD MMM YYYY")}</td>

                    <td
                      className="text-center"
                      style={{
                        display: "flex",
                        gap: "0.5rem",
                        justifyContent: "center",
                      }}
                    >
                      {/* VIEW */}
                      <Button
                        size="sm"
                        variant="outline-success"
                        onClick={() => viewHrOrgDocument(doc.documentId)}
                        style={{ fontSize: "18px", padding: "2px 15px" }}
                      >
                        <GrView />
                      </Button>

                      {/* DOWNLOAD */}
                      <Button
                        size="sm"
                        variant="outline-dark"
                        onClick={() => downloadHrOrgDocument(doc.documentId)}
                        style={{ fontSize: "18px", padding: "2px 15px" }}
                      >
                        <FaDownload />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <Alert variant="info" className="text-center">
              No documents found
            </Alert>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ViewHrOrgDocuments;
